import React from 'react';
import { Box, Image, Loader } from '@mantine/core';
import PuckInlineRichText from '../../proposal/ProposalRichText/PuckInlineRichText';
import classes from './LoadingPage.module.css';

const LoadingPage = ({
  id = 'loading-page',
  backgroundColor = '#0f172a',
  mediaKind = 'spinner',
  mediaUrlImage = '',
  mediaUrlVideo = '',
  mediaWidth = '12.5rem',
  spinnerType = 'oval',
  spinnerColor = '',
  spinnerSize = '3rem',
  title = '',
  subtitle = '',
  fadeType = 'fade',
  puck,
  mediaWrapRef,
  videoRef,
  /* Le viewer coupe la boucle native quand il compte les lectures : `loop`
     empêche `ended` de se déclencher. Partout ailleurs, la vidéo boucle. */
  loopVideo = true,
  exiting = false,
}) => {
  const isEditing = !!puck?.isEditing;
  const mediaUrl = mediaKind === 'video' ? mediaUrlVideo : mediaUrlImage;
  const hasMedia = mediaKind === 'spinner' || !!mediaUrl;
  // Vide = prend le maximum de place disponible (pas de taille intrinsèque
  // par défaut du navigateur, qui n'aurait rien à voir avec "max de place").
  const resolvedMediaWidth = mediaWidth || '100%';

  const fadeClass = classes[fadeType] || classes.fade;

  return (
    <Box
      className={`${classes.loadingRoot} ${isEditing ? classes.loadingRootEditing : ''} ${fadeClass} ${exiting ? classes.loadingRootExiting : ''}`.trim()}
      style={{ backgroundColor }}
      data-fade-type={fadeType}
    >
      {hasMedia ? (
        <div className={classes.mediaLayer}>
          <div className={classes.mediaWrap} ref={mediaWrapRef}>
            {mediaKind === 'spinner' ? (
              <Loader type={spinnerType} color={spinnerColor || undefined} size={spinnerSize} />
            ) : mediaKind === 'video' ? (
              // eslint-disable-next-line jsx-a11y/media-has-caption
              <video
                ref={videoRef}
                src={mediaUrl}
                autoPlay
                loop={loopVideo}
                muted
                playsInline
                style={{ width: resolvedMediaWidth, maxWidth: '100%' }}
              />
            ) : (
              <Image src={mediaUrl} alt="Chargement" w={resolvedMediaWidth} fit="contain" />
            )}
          </div>
        </div>
      ) : isEditing ? (
        <Box className={classes.emptyHint} c="dimmed" fz="sm">
          Ajoutez une image ou une vidéo dans les propriétés Puck
        </Box>
      ) : null}

      {(isEditing || title || subtitle) && (
        <div className={classes.textLayer}>
          {(isEditing || title) && (
            <PuckInlineRichText
              id={id}
              puck={puck}
              html={title}
              contentProp="title"
              className={classes.title}
              style={{ textAlign: 'center', width: '100%' }}
              minHeight={isEditing ? 36 : undefined}
              placeholder="Titre (optionnel)"
              alignHorizontal="center"
            />
          )}
          {(isEditing || subtitle) && (
            <PuckInlineRichText
              id={id}
              puck={puck}
              html={subtitle}
              contentProp="subtitle"
              className={classes.subtitle}
              style={{ textAlign: 'center', width: '100%' }}
              minHeight={isEditing ? 48 : undefined}
              placeholder="Sous-titre (optionnel)"
              alignHorizontal="center"
            />
          )}
        </div>
      )}
    </Box>
  );
};

export default LoadingPage;
